import { Box, Chip, Typography } from '@mui/material'
import axios from 'src/utilities/http-client'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { CancelIcon, CorrectIcon } from 'src/v3/core/icons'
import ConfirmAction from 'src/v3/components/confirm-action'
import {
  selectSelectedLinkedService,
  errorMessageChanged,
  selectLinkedServiceById,
  fetchLinkedServices,
} from '../admin.slice'

export default ({
  setFormOpen,
  formOpen,
}: {
  setFormOpen: (arg: string) => void
  formOpen: string
}) => {
  let dispatch = useAppDispatch()
  let selectedLinkedService = useAppSelector(selectSelectedLinkedService)
  let linkedService = useAppSelector(
    selectLinkedServiceById(selectedLinkedService),
  )

  let onCredentialVerificationChanged = () =>
    axios
      .put('/api/v2/admin/linked-service/credential-verification', {
        id: linkedService?.id,
        credentialVerification:
          linkedService?.credentialVerification === 'full'
            ? 'disabled'
            : 'full',
      })
      .then(() => dispatch(fetchLinkedServices()))
      .catch((err) => {
        dispatch(
          errorMessageChanged(
            err?.message || 'Error Changing Credential Verification Status',
          ),
        )
        dispatch(fetchLinkedServices())
      })

  return (
    <Box sx={{ mt: 1, width: 200 }}>
      <Box>
        <Typography variant="caption" color="text.secondary">
          Credential Verification
        </Typography>
      </Box>
      <Chip
        onClick={() => setFormOpen('credential-verification')}
        icon={
          linkedService?.credentialVerification === 'full' ? (
            <CorrectIcon />
          ) : (
            <CancelIcon />
          )
        }
        label={
          linkedService?.credentialVerification === 'full' ? 'Full' : 'Disabled'
        }
        variant={
          linkedService?.credentialVerification === 'full'
            ? 'filled'
            : 'outlined'
        }
        color={
          linkedService?.credentialVerification === 'full' ? 'success' : 'error'
        }
      />
      <ConfirmAction
        executeAction={onCredentialVerificationChanged}
        open={formOpen}
        setOpen={setFormOpen}
        openText="credential-verification"
        title="Confirm Status Change"
        text={`Are you sure you want to ${
          linkedService?.credentialVerification === 'full'
            ? 'disable'
            : 'enable'
        } credential verification for ${linkedService?.name}?`}
        onFailure={(err) =>
          dispatch(
            errorMessageChanged(
              `Error Deleting ${linkedService?.name || 'Linked Service'}: ${err}`,
            ),
          )
        }
      />
    </Box>
  )
}
